<template>
    <ul class="center_main_order">
        <li v-for="(item, index) in msg"
            :key="index">
            <a href="javascript:;"
                @click="handleJump(item.position)">
                <img :src="require('@/assets/img/centerMain/'+item.img)" alt="">
                <div>{{item.title}}</div>
                <div>{{num[index]}}</div>
            </a>
        </li>
    </ul>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    props: [ "msg", "num","pagePath"],
    methods: {
        ...mapMutations([
            "setOrderTabs"
        ]),
        handleJump(val){
			if(this.pagePath == 1){
				this.setOrderTabs(val);
				this.$router.push("/center/payStatus");
			}else{
				this.setOrderTabs(val);
				this.$router.push("/center/orderStatus");
			}
         
        }
    },
}
</script>

<style scoped>
/* 容器 */
.center_main_order{
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: nowrap;
}
/* 项目 */
.center_main_order>li>a{
    display: inline-block;
    padding: 30px 10px;
    color: #606266;
    text-align: center;
}
.center_main_order>li>a:hover{
    color: #FF6700;
}
/* 图标 */
.center_main_order>li>a>img{
    width: 50px;
    height: 50px;
}
.center_main_order>li>a>div{
    margin-top: 10px;
}
</style>
